import React from "react";

export default function TypeSelect(props) {

    if (props.types) {
        return (
            <div className={'form-group col-sm-4'}>
                <label htmlFor="type" className={"col-form-label"} >Type</label>
                <select id="type" value={props.selected} onChange={(e) => props.onChange(e.target.value) } className={"form-control"} >
                    <option value="any"> -- Any -- </option>
                    {props.types.map((type) => (
                        <option value={type.id} key={type.id}>
                            {type.name}
                        </option>
                    ))
                    }
                </select>
            </div>
        )
    }

}
